var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "参考"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#参考"
    }
  }, [_vm._v("#")]), _vm._v(" 参考")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://book.douban.com/subject/24722612/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("深入理解Java虚拟机（第2版）"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s/wn_7qve6OCD0SpYILvcKtg",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("这次，真正学懂 Java 垃圾回收机制"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s/8NkjFJ_Uy0CStZNKxZUR2g",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("不用找了，深入理解G1垃圾收集器和GC日志，都整理好了"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzA3MTUzOTcxOQ==&mid=2452965917&idx=1&sn=e9352b6b722fbe80b424bbcf715f8379&scene=21#wechat_redirect",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("46张PPT讲述JVM、GC算法和性能调优"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.oracle.com/cn/technical-resources/articles/java/g1gc.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("垃圾优先型垃圾回收器调优"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://tech.meituan.com/2017/12/29/jvm-optimize.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("从实际案例聊聊Java应用的GC优化"), _c('OutboundLink')], 1)])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "垃圾回收区域"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#垃圾回收区域"
    }
  }, [_vm._v("#")]), _vm._v(" 垃圾回收区域")]), _vm._v(" "), _c('p', [_vm._v("内存垃圾回收的目的是未必避免程序在运行过程中出现内存溢出和内存泄漏问题。")]), _vm._v(" "), _c('p', [_vm._v("JVM内存划分中，程序计数器、本地方法栈、虚拟机栈所需要的内存大小在代码结构确定后就已知的，并且会随着线程的生命周期创建和销毁，所以这部分内存分配具有确定性，不需要过多关注。")]), _vm._v(" "), _c('p', [_vm._v("而对于堆和方法区，需要多大内存是要在运行时才能知道的，因为方法的参数不同，调用次数不同，这些都是在运行期动态生成的，所以垃圾回收的职责就是对这部分垃圾对象进行回收，释放内存。")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("回收方法区：java虚拟机规范中，不要求方法区实现垃圾收集器，主要是对方法区进行垃圾收集的性价比不高，但是方法区也是可以在运行时产生新的字面量和类的。例如new String(\"abc\")的时候，如果常量池中不存在“abc”这个对象，则会在常量池中创建。JSP的实现过程是将新的servlet类加载到jvm中。")]), _vm._v(" "), _c('p', [_vm._v("所以方法区（HotSpot用永久代实现方法区）的垃圾回收主要包括：废弃常量和无用类。\n是否对类进行回收HotSpott提供了-Xnoclassgc来控制")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("方法区内存的回收查看《深入理解Java虚拟机（第2版）》3.2.5章节")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "判断哪些对象可以回收"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#判断哪些对象可以回收"
    }
  }, [_vm._v("#")]), _vm._v(" 判断哪些对象可以回收")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("引用计数法：为每个对象创建一个引用计数器，统计所有指向该对象的引用个数，当一个对象引用个数为0时，则说明对象没有引用可以回收")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("缺点：引用计数法无法处理循环引用的对象")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("可达性分析法：通过“GC Roots”对象集往下搜索引用链，当一个引用链无法到达“GC Roots”时，则说明该引用链的所有对象可以回收（obj5、obj6、obj7无法到达GC Roots，所以可以被回收）。")])])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/java/jvm/gc-roots.png",
      "alt": "可达性分析法"
    }
  })]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("引用计数法是目前主流的垃圾标记算法，GC Roots包括")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("虚拟机栈中引用的对象")]), _vm._v(" "), _c('li', [_vm._v("方法区中静态属性引用的对象")]), _vm._v(" "), _c('li', [_vm._v("方法区中常量引用的对象")]), _vm._v(" "), _c('li', [_vm._v("本地方法（JNI）栈中引用的对象")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "垃圾回收算法"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#垃圾回收算法"
    }
  }, [_vm._v("#")]), _vm._v(" 垃圾回收算法")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("标记-清除算法（Mark-Sweep）：最基本的垃圾收集算法，逻辑简单，缺点：效率偏低，容易产生内存碎片")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/java/jvm/gc-mark-sweep.png",
      "alt": "gc-mark-sweep"
    }
  })])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("复制算法（Copying）：逻辑简单、效率高、没有内存碎片，但是内存使用率不高，适合存活对象少（需要复制的对象少）的情况")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/java/jvm/gc-copying.png",
      "alt": "gc-copying"
    }
  })])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("标记-整理算法（Mark-Compact）：内存利用率高，没有内存碎片，适合存活对象多，垃圾少的情况（需要移动位置的对象少）")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/java/jvm/gc-compact.png",
      "alt": "gc-compact"
    }
  })])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "分代垃圾回收"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#分代垃圾回收"
    }
  }, [_vm._v("#")]), _vm._v(" 分代垃圾回收")]), _vm._v(" "), _c('p', [_vm._v("以上垃圾回收算法各自都有优缺点，为了针对不同场景，jvm开发者对内存做了划分，针对不同区域使用不同的回收算法。")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新生代\n"), _c('ul', [_c('li', [_vm._v("大部分对象在gc时被回收，存活对象少，使用复制算法。为了解决内存占用过高问题，将新生代划分成了Eden, Survivors(s0, s1或者from, to)，内存分配比例是Eden:from:to = 8:1:1")])])]), _vm._v(" "), _c('li', [_vm._v("老年代\n"), _c('ul', [_c('li', [_vm._v("经过多次gc后依然存活的对象进入老年代，所以gc时存活对象多，使用“标记-清除”或者“标记-整理”算法")])])])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("详细查看《深入理解Java虚拟机（第2版）》3.3章节")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "垃圾对象转移和收集过程"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#垃圾对象转移和收集过程"
    }
  }, [_vm._v("#")]), _vm._v(" 垃圾对象转移和收集过程")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("新对象在Eden区创建，当Eden区快满的时候，进行Minor GC(YGC)，将Eden清空，把存活对象放到From区，然后新对象继续在Eden区创建。")]), _vm._v(" "), _c('li', [_vm._v("当Eden区又满的时候，进行Minor GC(YGC)，清理Eden区和From区垃圾对象，把存活对象放到To区，依次类推，From区和To区交替使用。")]), _vm._v(" "), _c('li', [_vm._v("当对象经过多次Minor GC(YGC)后依然存活（超过回收年龄，不同垃圾收集器的阈值不一样，可以通过参数修改），进入老年代（Old区）。")]), _vm._v(" "), _c('li', [_vm._v("如果存活对象太多，From区或者To区放不下，则直接进入Old区。")]), _vm._v(" "), _c('li', [_vm._v("Old区快满时（当内存使用比例达到一定阈值，不同收集器阈值不一样，cms收集器默认是92%），触发Major GC(FGC)，同时对新生代和老年代进行垃圾回收。")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "垃圾收集器"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#垃圾收集器"
    }
  }, [_vm._v("#")]), _vm._v(" 垃圾收集器")]), _vm._v(" "), _c('p', [_vm._v("各垃圾收集器类型和适用分代范围")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/java/jvm/garbage-collector.png",
      "alt": "JVM结构体系"
    }
  })]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "serial"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#serial"
    }
  }, [_vm._v("#")]), _vm._v(" Serial")]), _vm._v(" "), _c('p', [_vm._v("单线程串行收集器，用于新生代垃圾收集。使用“复制算法”，多用于客户端程序。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "serial-old"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#serial-old"
    }
  }, [_vm._v("#")]), _vm._v(" Serial Old")]), _vm._v(" "), _c('p', [_vm._v("Serial的老年代版本，同样是单线程收集器，使用“标记-整理”算法。多用于客户端程序，同时作为CMS担保失败后的备预案收集器。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "parnew"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#parnew"
    }
  }, [_vm._v("#")]), _vm._v(" ParNew")]), _vm._v(" "), _c('p', [_vm._v("Serial的多线程版本，同时是使用“复制算法”，目的是为了充分利用cpu资源，缩短停顿时间。适用于多线程的服务器程序，配合CMS收集器一起使用")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "parallel-scavenge"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#parallel-scavenge"
    }
  }, [_vm._v("#")]), _vm._v(" Parallel Scavenge")]), _vm._v(" "), _c('p', [_vm._v("与ParNew一样，是使用复制算法的并发新生代收集器。不同之处在于Parallel Scavenge是吞吐量优先的，可以设置期望停顿时间（MaxGCPauseMillis）和吞吐量（GCTimeRatio），但是无法与CMS仪器配合使用。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "parallel-old"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#parallel-old"
    }
  }, [_vm._v("#")]), _vm._v(" Parallel Old")]), _vm._v(" "), _c('p', [_vm._v("Parallel Scavenge的老年代版本，使用”标记-整理“算法。在JDK1.6之后提供，为了配合Parallel Scavenge实现高吞吐量的收集器组合。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "cms"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#cms"
    }
  }, [_vm._v("#")]), _vm._v(" CMS")]), _vm._v(" "), _c('p', [_vm._v("低停顿的并发收集器，部分阶段能够与用户线程同时进行。采用“标记-清除”算法，多用于web等对延迟要求较高的系统。")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("随着垃圾收集器的发展，在JDK1.9中CMS已经被标记为废弃")])]), _vm._v(" "), _c('p', [_c('em', [_c('strong', [_vm._v("垃圾收集过程")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("初始标记（initial mark）： stop the world，仅标记GC Roots能直接关联到的对象，速度很快；")]), _vm._v(" "), _c('li', [_vm._v("并发标记（concurrent mark）： 进行GC Roots Tracing的过程；")]), _vm._v(" "), _c('li', [_vm._v("重新标记（remark）： stop the world，修正并发标记期间因用户程序继续运作而导致标记产生变动的那一部分对象的标记记录，这个阶段的停顿时间一般会比初始标记阶段稍长一些，但比并发标记时间短；")]), _vm._v(" "), _c('li', [_vm._v("并发清除（concurrent sweep）： 整个过程中耗时最长的并发标记和并发清除过程收集器线程都可以与用户线程一起工作，所以，从总体上来说，CMS收集器的内存回收过程是与用户线程一起并发执行的。")])]), _vm._v(" "), _c('p', [_c('em', [_c('strong', [_vm._v("优缺点")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("优点：并发收集、低停顿")]), _vm._v(" "), _c('li', [_vm._v("缺点\n"), _c('ol', [_c('li', [_vm._v("对CPU资源非常敏感，会与用户线程抢占cpu资源，在cpu资源不足的情况下同样会影响程序执行")]), _vm._v(" "), _c('li', [_vm._v("无法处理浮动垃圾、产生大量空间碎片")]), _vm._v(" "), _c('li', [_vm._v("因为cms在垃圾收集时，用户线程同时运行，在这期间产生的垃圾超过可提供的内存空间时，cms将临时采用后预案，使用Serial Old对老年代重新进行垃圾收集。")])])])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("-XX:CMSinitiatingoccupancyFraction可以设置老年代达到内存占用比例时触发cms，即预留多少空间给垃圾收集期间同时产生的对象。")]), _vm._v(" "), _c('p', [_vm._v("JDK1.5 默认是68%，JDK1.6默认值调整到了92%")]), _vm._v(" "), _c('p', [_vm._v("如果老年代内存增长较快时可适当调低，反之可以适当调高")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "g1"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#g1"
    }
  }, [_vm._v("#")]), _vm._v(" G1")]), _vm._v(" "), _c('p', [_vm._v("同样是以低延迟为目标的并发收集器，在高并发和大内存下表现很好，在JDK1.9中成为了默认垃圾收集器。物理上已经没有严格的年代划分，将堆内存划分成多个region，针对每个region进行收集，没有垃圾碎片，可以设置期望停顿时间。如果最求高吞吐量，G1并不是一个好的选择。")]), _vm._v(" "), _c('p', [_vm._v("优点：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("大内存友好，相对于 cms 如果内存设置较大，在重新标记阶段可能会造成比较长时间停顿")]), _vm._v(" "), _c('li', [_vm._v("没有内存碎片")]), _vm._v(" "), _c('li', [_vm._v("可预测暂停时间，可以解决突发流量导致的内存突然增加情况")])]), _vm._v(" "), _c('p', [_vm._v("劣势：牺牲一定吞吐量")]), _vm._v(" "), _c('p', [_vm._v("参考：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("详细可查看《深入理解java虚拟机（第2版）》3.5.7章节，")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s/8NkjFJ_Uy0CStZNKxZUR2g",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("不用找了，深入理解G1垃圾收集器和GC日志，都整理好了"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://tech.meituan.com/2016/09/23/g1.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Java Hotspot G1 GC的一些关键技术"), _c('OutboundLink')], 1)])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "常用gc收集器组合"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#常用gc收集器组合"
    }
  }, [_vm._v("#")]), _vm._v(" 常用GC收集器组合")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("垃圾收集器")]), _vm._v(" "), _c('th', [_vm._v("回收算法")]), _vm._v(" "), _c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Serial "), _c('br'), _vm._v(" Serial Old")]), _vm._v(" "), _c('td', [_vm._v("复制算法 "), _c('br'), _vm._v(" 标记-整理算法")]), _vm._v(" "), _c('td', [_vm._v("-XX:+UseSerialGC "), _c('br'), _vm._v("(Serial + Serial Old)")]), _vm._v(" "), _c('td', [_vm._v("单线程，不能充分利用CPU，多用于client模式")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Parallel Scavenge "), _c('br'), _vm._v(" Parallel Old")]), _vm._v(" "), _c('td', [_vm._v("复制算法 "), _c('br'), _vm._v(" 标记-整理算法")]), _vm._v(" "), _c('td', [_vm._v("-XX:+UseParallelOldGC "), _c('br'), _vm._v("(Parallel Scavenge + Parallel Old)")]), _vm._v(" "), _c('td', [_vm._v("多线程，并行收集，高吞吐量")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ParNew "), _c('br'), _vm._v(" CMS")]), _vm._v(" "), _c('td', [_vm._v("复制算法 "), _c('br'), _vm._v(" 标记-清除算法")]), _vm._v(" "), _c('td', [_vm._v("-XX:+UseConcMarkSweepGC "), _c('br'), _vm._v(" (ParNew + CMS)")]), _vm._v(" "), _c('td', [_vm._v("多线程，追求极致低延迟")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("G1")]), _vm._v(" "), _c('td', [_vm._v("复制算法 +"), _c('br'), _vm._v("标记整理")]), _vm._v(" "), _c('td', [_vm._v("-XX:+UseG1GC "), _c('br'), _vm._v("-XX:MaxGCPauseMillis=100 "), _c('br'), _vm._v("(可选，期望停顿时间ms)")]), _vm._v(" "), _c('td', [_vm._v("多线程，低延迟，JDK1.9中默认的收集器")])])])]), _vm._v(" "), _c('div', {
    staticClass: "custom-block tip"
  }, [_c('p', {
    staticClass: "custom-block-title"
  }, [_vm._v("提示")]), _vm._v(" "), _c('p', [_vm._v("如果 JDK 版本是 1.8 以上，推荐使用 G1 收集器")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("G1 在大内存下表现比 CMS 好，现在硬件成本越来越低，很多 GC 问题，只要多分配一些内存就能很好解决")]), _vm._v(" "), _c('li', [_vm._v("G1 可以设置最长停顿时间，一次 GC 可以只回收部分内存，保证一次 GC 在预期时长之内，能更好应对对突发高并发场景")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };